import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

const spans = [
  "lg:col-span-3",
  "lg:col-span-3",
  "lg:col-span-2",
  "lg:col-span-2",
  "lg:col-span-2",
  "lg:col-span-6",
];

const Features = () => {
  const { t } = useLanguage();

  return (
    <section id="features" className="relative py-24 sm:py-32" data-testid="features-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-600">
            {t.features.overline}
          </p>
          <h2 className="mt-4 max-w-2xl font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            {t.features.title}
          </h2>
          <p className="mt-4 max-w-2xl text-base text-slate-600 sm:text-lg">{t.features.subtitle}</p>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-6">
          {t.features.items.map((f, i) => (
            <Reveal key={f.num} delay={i * 0.07} className={spans[i]}>
              <article
                data-testid={`feature-card-${f.num}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-sky-100 bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-amber-300/70 hover:shadow-2xl hover:shadow-amber-500/10"
              >
                <span className="pointer-events-none absolute -end-3 -top-7 font-heading text-[7rem] font-extrabold leading-none text-sky-50 transition-colors duration-300 group-hover:text-amber-100/70">
                  {f.num}
                </span>
                <span className="relative font-mono text-xs font-bold tracking-[0.2em] text-sky-600">
                  {f.num}
                </span>
                <h3 className="relative mt-4 font-heading text-xl font-semibold text-slate-900 sm:text-2xl">
                  {f.title}
                </h3>
                <p className="relative mt-3 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
                  {f.desc}
                </p>
                <span className="absolute bottom-0 start-0 h-1 w-0 bg-gradient-to-r from-sky-500 to-amber-400 transition-all duration-500 group-hover:w-full" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
